export const INIT_APP = 'INIT_APP';

export const GET_ME_REQUESTED = 'GET_ME_REQUESTED';
export const GET_ME_SUCCEEDED = 'GET_ME_SUCCEEDED';
export const GET_ME_FAILED = 'GET_ME_FAILED';

export const GET_CURRICULUMS = "GET_CURRICULUMS";
export const GET_CURRICULUMS_SUCCEEDED = "GET_CURRICULUMS_SUCCEEDED";
export const GET_CURRICULUMS_FAILED = "GET_CURRICULUMS_FAILED";

export const GET_GRADES = "GET_GRADES";
export const GET_GRADES_SUCCEEDED = "GET_GRADES_SUCCEEDED";
export const GET_GRADES_FAILED = "GET_GRADES_FAILED";

export const GET_GRADE_DETAILS = "GET_GRADE_DETAILS";
export const GET_GRADE_DETAILS_SUCCEEDED = "GET_GRADE_DETAILS_SUCCEEDED";
export const GET_GRADE_DETAILS_FAILED = "GET_GRADE_DETAILS_FAILED";

export const GET_CCFILTRERS = "GET_CCFILTRERS";
export const GET_CCFILTRERS_SUCCEEDED = "GET_CCFILTRERS_SUCCEEDED";
export const GET_CCFILTRERS_FAILED = "GET_CCFILTRERS_FAILED";

export const GET_CCSubjects = "GET_CCSubjects";
export const GET_CCSubjects_SUCCEEDED = "GET_CCSubjects_SUCCEEDED";
export const GET_CCSubjects_FAILED = "GET_CCSubjects_FAILED";

export const GET_SKILL_CONFIGS = "GET_SKILL_CONFIGS";
export const GET_TOPIC_CONFIGS = "GET_TOPIC_CONFIGS";
export const GET_CONCEPT_CONFIGS = "GET_CONCEPT_CONFIGS";
export const GET_SKILL_CONFIGS_SUCCEEDED = "GET_SKILL_CONFIGS_SUCCEEDED";
export const GET_SKILL_CONFIGS_FAILED = "GET_SKILL_CONFIGS_FAILED";

export const GET_USER_REFRESH_REQUESTED = 'GET_USER_REFRESH_REQUESTED';
export const GET_USER_REFRESH_SUCCEEDED = 'GET_USER_REFRESH_SUCCEEDED';
export const GET_USER_REFRESH_FAILED = 'GET_USER_REFRESH_FAILED';

export const SEND_FOR_DOWNLOAD_REQUESTED = 'SEND_FOR_DOWNLOAD_REQUESTED';
export const SEND_FOR_DOWNLOAD_SUCCEEDED = 'SEND_FOR_DOWNLOAD_SUCCEEDED';
export const SEND_FOR_DOWNLOAD_FAILED = 'SEND_FOR_DOWNLOAD_FAILED';

export const ADD_QUESTION_TO_DOWNLOAD = "ADD_QUESTION_TO_DOWNLOAD"
export const REMOVE_QUESTION_TO_DOWNLOAD = "REMOVE_QUESTION_TO_DOWNLOAD"
export const REMOVE_ALL_QUESTION_TO_DOWNLOAD = "REMOVE_ALL_QUESTION_TO_DOWNLOAD"

export const ADD_SECTION = "ADD_SECTION"
export const REMOVE_SECTION = "REMOVE_SECTION"
export const EDIT_SECTION = "EDIT_SECTION"

export const DRAG_UPDATE = "DRAG_UPDATE"

export const SAVE_EXAM_INSTRUCTION = "SAVE_EXAM_INSTRUCTION"

export const SAVE_INSTRUCTION="SAVE_INSTRUCTION"

export const CLEAR_DOWNLOAD="CLEAR_DOWNLOAD";


export const clearDownload = (payload) => {
  return {
    type: CLEAR_DOWNLOAD,
    payload
  };
};


export const saveInstrictionInfo=(payload)=>{
  return {
    type :SAVE_INSTRUCTION,
    payload
  }
}

export const initApp = () => {
  return {
    type: INIT_APP,
  };
};

export const getMe = () => {
  return {
    type: GET_ME_REQUESTED,
  };
};

export const getCurriculums = (payload) => {
  return {
    type: GET_CURRICULUMS,
    payload
  };
};

export const getGrades = (payload) => {
  return {
    type: GET_GRADES,
    payload
  };
};

export const getGradeDetails = (payload) => {
  return {
    type: GET_GRADE_DETAILS,
    payload
  };
};

export const getCCFilters = () => {
  return {
    type: GET_CCFILTRERS,
  };
}
export const getCCSubjects = () => {
  return {
    type: GET_CCSubjects,
  };
}

export const getSkillConfigs = (payload) => {
  return {
    type: GET_SKILL_CONFIGS,
    payload
  };
};

export const getTopicConfigs = (payload) => {
  return {
    type: GET_TOPIC_CONFIGS,
    payload,
  };
};


export const getConceptConfigs = (payload) => {
  return {
    type: GET_CONCEPT_CONFIGS,
    payload,
  };
};


export const refreshUser = () => {
  return {
    type: GET_USER_REFRESH_REQUESTED,
  };
};

export const addQuestionToDownload = (payload) => {
  return {
    type: ADD_QUESTION_TO_DOWNLOAD,
    payload
  };
};

export const removeQuestionToDownload = (payload) => {
  return {
    type: REMOVE_QUESTION_TO_DOWNLOAD,
    payload
  };
};

export const sendForDownload = (payload) => {
  return {
    type: SEND_FOR_DOWNLOAD_REQUESTED,
    payload
  };
};

export const removeAllQuestionToDownload = (payload) => {
  return {
    type: REMOVE_ALL_QUESTION_TO_DOWNLOAD,
  };
};

export const editSection = (payload) => {
  return {
    type: EDIT_SECTION,
    payload
  };
};

export const addSection = (payload) => {
  return {
    type: ADD_SECTION,
    payload
  };
};

export const removeSection = (payload) => {
  return {
    type: REMOVE_SECTION,
    payload
  };
};

export const dragUpdate = (payload) => {
  return {
    type: DRAG_UPDATE,
    payload
  };
};

export const saveExamInstruction = examObj => {
  return {
    type: SAVE_EXAM_INSTRUCTION,
    examObj
  }
}